import { createContext, useContext } from 'react'

export enum FlowContext {
  DIRECT,
  POST_QUOTE,
}

const FlowContextContext = createContext<FlowContext | null>(null)

export const FlowContextProvider = FlowContextContext.Provider

export const useFlowContext = () => {
  const flowContext = useContext(FlowContextContext)

  if (flowContext === null) {
    throw new Error('`useFlowContext` should be used with `FlowContextProvider` as a parent')
  }

  return flowContext
}
